import { Separator } from "@/components/ui/separator";
import { Facebook, Linkedin } from "lucide-react";

const AVATAR_URL = "/images/logo-avatar.png";
const CTA_URL = "https://diyb.ca/contact-diyb/";
const EMAIL = "paul@whitebeardsolutions.com";

const SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://facebook.com/WhiteBeardSolutions",
    icon: Facebook,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/paulhughes/",
    icon: Linkedin,
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#020617] border-t border-slate-800/50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={AVATAR_URL}
                alt="White Beard Solutions"
                className="w-10 h-10 rounded-full border-2 border-gold/40"
              />
              <div>
                <p className="font-heading font-bold text-lg text-slate-50 tracking-wide">
                  WHITE BEARD <span className="text-gold">SOLUTIONS</span>
                </p>
              </div>
            </div>
            <p className="font-body text-sm text-slate-400 leading-relaxed mb-4">
              The personal brand of{" "}
              <a
                href="https://ph.mba"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 underline underline-offset-2 hover:text-gold transition-colors duration-300"
              >
                Paul Hughes
              </a>
              , the Master Business Craftsman behind{" "}
              <a
                href="https://diyb.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 underline underline-offset-2 hover:text-gold transition-colors duration-300"
              >
                Doorways Into Your Business
              </a>
              .
            </p>
            {/* Social Media Links */}
            <div className="flex items-center gap-3">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 rounded-full bg-slate-800/50 border border-slate-700/50 flex items-center justify-center text-slate-400 hover:text-gold hover:border-gold/50 hover:bg-slate-800 transition-all duration-300"
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p className="font-heading font-bold text-sm tracking-widest uppercase text-gold mb-4">
              Navigate
            </p>
            <div className="space-y-2">
              {[
                { label: "The Shift", href: "#shift" },
                { label: "What I Build", href: "#services" },
                { label: "The Craftsman Code", href: "#philosophy" },
                { label: "Proof", href: "#proof" },
                { label: "How It Works", href: "#how-it-works" },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block font-body text-sm text-slate-400 hover:text-slate-300 transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="font-heading font-bold text-sm tracking-widest uppercase text-gold mb-4">
              Get Started
            </p>
            <p className="font-body text-sm text-slate-400 leading-relaxed mb-4">
              <a
                href="https://diyb.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 underline underline-offset-2 hover:text-gold transition-colors duration-300"
              >
                Doorways Into Your Business
              </a>{" "}
              builds and installs Smart Digital Doorways, Smart Websites,
              and Smart Solutions for local businesses in Kingsville, Ontario
              and the Windsor-Essex Region.
            </p>
            <a
              href={CTA_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta-link"
              className="inline-block font-heading font-bold text-sm tracking-widest uppercase text-gold hover:text-gold-300 transition-colors duration-300 border-b border-gold/30 hover:border-gold pb-1"
            >
              Contact Us
            </a>
            <p className="font-body text-sm text-slate-400 mt-4">
              <a
                href={`mailto:${EMAIL}`}
                data-testid="footer-email-link"
                className="text-slate-300 underline underline-offset-2 hover:text-gold transition-colors duration-300"
              >
                {EMAIL}
              </a>
            </p>
          </div>
        </div>

        <Separator className="bg-slate-800/50 mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-slate-500">
            Crafted in Kingsville, Ontario
          </p>
          <p className="font-body text-xs text-slate-500">
            Copyright &copy; 2026 White Beard Solutions (WBS) &middot;{" "}
            <a
              href="https://diyb.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-slate-400 transition-colors duration-200"
            >
              Doorways Into Your Business
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
